module.exports = __webpack_public_path__ + "img/sunrise_2.cf36c231.png";